import router from '../router';
import { createGtm } from '@gtm-support/vue-gtm';

const gtm = createGtm({
  id: import.meta.env.VITE_GTM_ID || '',
  defer: false,
  debug: false,
  loadScript: true,
  vueRouter: router,
  ignoredViews: ['NotFound'],
  trackOnNextTick: true,
});

export default gtm